<template>
  <b-tabs v-model="activeTab" :animated="false">
    <b-tab-item value="translator-check" icon="check" :label="$t('translatorCheck')">
      <TranslatorCheck :translator="translator" />
    </b-tab-item>
    <b-tab-item value="events" icon="calendar" :label="$t('events')">
      <div>
        <b-message type="is-primary">
          {{ $t("transaltorAddEvent") }}
        </b-message>
      </div>
    </b-tab-item>
    <b-tab-item value="affiliate" icon="certificate-outline" :label="$t('affiliateTools')">
      <div class="columns">
        <div class="column">
          <b-message type="is-primary">
            <span v-html="$t('transExpPositives')" />
            <br /><br />
            {{ $t("transExpPartner") }}
          </b-message>
          <b-button class="mt-2" icon-left="plus" @click="$router.push({ path: '/login' })">
            {{ $t("createOrganizationOrChangeTo") }}
          </b-button>
        </div>
        <div class="column">
          <div style="height: 315px; display: table-cell">
            <video width="560" height="315px" controls>
              <source :src="PARTNER_VIDEO_LINK" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </b-tab-item>
    <b-tab-item value="settings" icon="cog-outline" :label="$t('settings')">
      <TranslatorSettings :translator="translator" />
    </b-tab-item>
    <b-tab-item v-if="false" value="billing" icon="account-cash-outline" :label="$t('billing')">
      <TranslatorBilling :translator="translator" />
    </b-tab-item>
    <b-tab-item value="demo" icon="test-tube-empty" :label="$t('demo')">
      <TranslatorDemo :translator="translator" />
    </b-tab-item>
  </b-tabs>
</template>

<script>
//import AffiliateTools from './AffiliateTools'
import TranslatorSettings from "./TranslatorSettings";
import TranslatorBilling from "./TranslatorBilling";
import TranslatorCheck from "./TranslatorCheck";
import TranslatorDemo from "./TranslatorDemo";
//import {db} from '@/firebase'
import { PARTNER_VIDEO_LINK } from "@/env";

export default {
  name: "TranslatorTabs",
  components: {
    TranslatorSettings,
    TranslatorBilling,
    TranslatorCheck,
    TranslatorDemo,
  },
  props: {
    translator: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      activeTab: 0,
      events: [],
      bills: [],
      mandates: [],
      admins: [],
      organizations: [],
      errors: [],
      settings: [],
      save: false,
      PARTNER_VIDEO_LINK,
    };
  },
  computed: {},
  watch: {
    activeTab() {},
  },
  firestore() {
    return {};
  },
};
</script>
